export const PPAA = {
  id: 'PPAA',
  value: 'Uso interno',
  amountTaxStamp: 0,
  amountRightsSecretariat: 0,
  amountRightsCivilState: 0,
  amountFixedRights: 0,
  amountExpenses: 0,
  codeExemptionAnpr: '10',
  registryType: 'ESENTE',
  descrizioneModalitaStampa: '',
};

export const ELETT = {
  id: 'ELETT',
  value: 'Elettorale-Eserc. diritti e tutela',
  amountTaxStamp: 0,
  amountRightsSecretariat: 0.26,
  amountRightsCivilState: 0,
  amountFixedRights: 0,
  amountExpenses: 0,
  codeExemptionAnpr: '11',
  registryType: 'ESENTE',
  descrizioneModalitaStampa:
    "RILASCIATO IN CARTA LIBERA ai sensi dell'art.1 Tab. B D.P.R.26 ottobre 1972, n.642 per uso elettorale (esercizio diritti e tutela). Esente dai diritti di segreteria ai sensi della L.8/6/62 n.604 Tab.D p.8",
  item: {
    note: null,
    tipoRegistroVO: null,
    codiceImpDirittiStatoCivile: 'DC00',
    importoDirittiStatoCivile: '0.00',
    codiceImpDirittiFissi: 'DF00',
    codiceImpImpostaBollo: 'BL00',
    codiceImpSpese: 'SP00',
    codiceUsoModalita: '4',
    tipoRegistro: 'ESENTE',
    codiceEsenzioneAnpr: '11',
    warning: null,
    key: {
      codiceModalitaRilascio: 'ELETT',
      codiceEnte: '01',
    },
    codiceOperatoreInserimento: 'FABIOT',
    timestampUltimoAggiornamento: '2024-03-13T11:30:38.876+01',
    importoSpese: '0.00',
    importoDirittiFissi: '0.00',
    dataInizioValidita: '2000-01-01T00:00:00.000+01',
    descrizioneModalitaStampa:
      "RILASCIATO IN CARTA LIBERA ai sensi dell'art.1 Tab. B D.P.R.26 ottobre 1972, n.642 per uso elettorale (esercizio diritti e tutela). Esente dai diritti di segreteria ai sensi della L.8/6/62 n.604 Tab.D p.8",
    dataFineValidita: '9999-12-31T00:00:00.000+01',
    importoImpostaBollo: '0.00',
    codiceImpDirittiSegreteria: 'DS01',
    codiceOperatoreUltimoAggiornamento: 'raffa',
    descrizione: 'Elettorale-Eserc. diritti e tutela',
    importoDirittiSegreteria: '0.26',
    timestampInserimento: null,
  },
};
